import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-uom',
  templateUrl: './uom.component.html',
  styleUrls: ['./uom.component.css']
})
export class UomComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  paramData: any = []
  uomData: any = []
  imgUrl1 = ''
  imgUrl2 = ''
  file1: File | undefined;
  file2: File | undefined;
  singleUomMaster: any = []
  deleteUomMasterId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid: any
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  id: any = ""
  recordName: any = ""
  recordId: any = ""
  searchKey: any = ""

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {

    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllUomMaster()
    this.form = this.fb.group({
      uomName: ['', [Validators.required]],
      description: [''],
      nameValueList: this.fb.array([]),
    })
    this.editForm = this.fb.group({
      uomName: ['', [Validators.required]],
      description: [''],
      nameValueList: this.fb.array([]),
    })
    this.addInfoObject()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllUomMaster();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllUomMaster();
  }

  get paramArr() {
    return this.form.get('nameValueList') as FormArray;
  }

  paramObject() {
    return this.fb.group({
      "name": [''],
      "value": [''],
    })
  }

  addInfoObject() {
    this.paramArr.push(this.paramObject())
  }

  removeParamObject(index: number) {
    this.paramArr.removeAt(index)
  }

  get paramArrEdit() {
    return this.editForm.get('nameValueList') as FormArray;
  }

  paramEditObject() {
    return this.fb.group({
      "name": [''],
      "value": [''],
    })
  }

  addEditInfoObject() {
    this.paramArrEdit.push(this.paramObject())
  }

  removeEditParamObject(index: number) {
    this.paramArrEdit.removeAt(index)
  }

  addUOM() {

    if (!this.form.valid) {
      this.toastr.error("please fill required fields");
      return
    }


    const uomName = this.form.get('uomName').value?.trim();
    const description = this.form.get('description').value?.trim();

    if (!uomName) {
      this.toastr.error("UOM Name is required");
      return;
    }

    // Duplicate check
    // const isDuplicate = this.uomData.some((uom: any) => uom.uomName.trim().toLowerCase() === uomName.toLowerCase());
    // if (isDuplicate) {
    //   this.toastr.error("UOM Name already exists");
    //   return;
    // }

    let body = {
      "version": 0,
      "isActive": true,
      "description": description || '',
      "uomName": uomName,
      "nameValueList": this.form.get('nameValueList').value.map((item: any) => ({
        name: item.name?.trim() || '',
        value: item.value?.trim() || ''
      })),
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.addUomMaster(body).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllUomMaster()
        this.cancelModel()
        this.form.reset()
        this.toastr.success(response.message)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);

      }
    )
  }

  formReset() {
    this.form.reset()
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllUomMaster() {
    this.isLoading = true

    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        console.log(res)
        this.uomData = res.response
        this.count = res.response.length
        this.isLoading = false

      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getUomMasterById(id: any) {
    this.generic_service.getUomMasterById(id).subscribe(
      (res: any) => {
        console.log(res)
        this.singleUomMaster = []
        this.singleUomMaster.push(res.response)
        this.editForm.patchValue({
          uomName: res.response.uomName,
          description: res.response.description,
        })
        for (var i = 0; i < res.response.nameValueList.length; i++) {
          // this.fb.group({
          //   "name": res.response.nameValueList[i].name,
          //   "value": res.response.nameValueList[i].value
          // })
          this.paramArrEdit.push(this.fb.group({
            "name": res.response.nameValueList[i].name,
            "value": res.response.nameValueList[i].value
          }))
        }
        console.log(this.editForm.value)
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  deleteUomMaster() {
    this.generic_service.deleteUomMaster(this.id).subscribe(
      (response: any) => {
        console.log(response);
        document.getElementById("deleteModalButton")?.click()
        this.toastr.success(response.message)
        this.getAllUomMaster()
        this.recordName = ""
        this.recordId = ""
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  selectDelete(id: any, record: any) {
    this.id = id;
    this.recordId = record.uomMasterId;
    this.recordName = record.uomName;
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }


  getAllUOMMasterByWildSearchWithoutPagination() {
    console.log(this.searchKey)
    if (this.searchKey == "" || this.searchKey == null) {
      return
    }
    this.generic_service.getAllUOMMasterByWildSearchWithoutPagination(this.searchKey).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.uomData = []
          this.count = 0
          return

        }
        this.uomData = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );



  }

  refreshAll() {
    this.page = 1
    this.first = 0
    this.searchKey = ""
    this.getAllUomMaster()
  }
}
